export default "{% for user in users %}\n* {{ user.name }}\n{% else %}\nNo users have been found.\n{% endfor %}\n"